import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMultistage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.575 33.9H23.45v-2.875H12.575zm6-8.475H29.45V22.55H18.575zm6-8.475H35.45v-2.875H24.575zM9.1 41.775q-1.149 0-2.011-.864-.864-.862-.864-2.011V9.1q0-1.149.864-2.011.862-.864 2.011-.864h29.8q1.148 0 2.012.864.863.862.863 2.011v29.8q0 1.149-.863 2.011-.864.864-2.012.864zm0-2.875h29.8V9.1H9.1z" })
});
export default SvgMultistage;
